<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2" id="calibre_pb_0"></div>
<p class="p_norm-center__and__page_break" id="auto_bookmark_toc_1"><span>To my dad. Thank you for everything. You’re my hero.</span></p>
<p class="p_norm-center__and__page_break"><span>To Maria and Cara for always being there.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?76e90de0